"use strict";
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __decorateClass = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result)
    __defProp(target, key, result);
  return result;
};
import { Annotation, CoreModel } from "@ym-framework/model";
import { DataSetModel } from "@/models/dataset.model";
import { TagsModel } from "@/models/tags.model";
export let GroupsModel = class extends CoreModel {
  constructor() {
    super(...arguments);
    this.tabs = new DataSetModel();
  }
};
GroupsModel.model = "groups";
GroupsModel = __decorateClass([
  Annotation.ModelMeta
], GroupsModel);
export let GroupModel = class extends CoreModel {
  constructor() {
    super(...arguments);
    this.id = "";
    this.name = "";
    this.type = "system";
    this.source = "/api/v3/virtual_desktops/groups";
    this.prames = {
      "groupId": ""
    };
    this.num = 0;
    this.marks = new TagsModel();
    this.visible = "PERSONAL";
  }
};
GroupModel.model = "group";
GroupModel = __decorateClass([
  Annotation.ModelMeta
], GroupModel);
export let GroupProModel = class extends CoreModel {
  constructor() {
    super(...arguments);
    this.id = "";
    this.name = "";
    this.quantity = 0;
    this.type = "";
    this.visible = "";
  }
};
GroupProModel.model = "group";
GroupProModel = __decorateClass([
  Annotation.ModelMeta
], GroupProModel);
